import { render, staticRenderFns } from "./jcXmDetail.vue?vue&type=template&id=5a2cfa56&scoped=true&"
import script from "./jcXmDetail.vue?vue&type=script&lang=js&"
export * from "./jcXmDetail.vue?vue&type=script&lang=js&"
import style0 from "./jcXmDetail.vue?vue&type=style&index=0&id=5a2cfa56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2cfa56",
  null
  
)

export default component.exports